import { AudioOutlined } from '@ant-design/icons';
import { styled } from '@aibi-ui/core';
import { Tooltip } from 'antd';
import { useState } from 'react';
import RecordingIcon from './RecordingIcon';

const SpeechButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 4px;
    font-size: 16px;
    color: #1677ff;
    &:hover {
      background: #e6f4ff;
    }
  }
  .speeching {
    svg {
      width: 16px;
    }
  }
`;

const SpeechButton = () => {
  const [speeching, setSpeeching] = useState(false);
  const handleClick = () => {
    setSpeeching(!speeching);
  };
  return (
    <SpeechButtonContainer>
      {speeching ? (
        <Tooltip title="停止语音输入">
          <button className="speeching" onClick={handleClick}>
            <RecordingIcon />
          </button>
        </Tooltip>
      ) : (
        <Tooltip title="语音输入">
          <button onClick={handleClick}>
            <AudioOutlined />
          </button>
        </Tooltip>
      )}
    </SpeechButtonContainer>
  );
};

export default SpeechButton;
